module.exports = __webpack_public_path__ + "img/0-39.12d232c3.jpg";